<template>
    <ContentOrLoading>
        <div v-if="!loading && svgRendered" class="mt-2">
            <div class="d-flex items-center mb-2" v-if="plaza_abonado">
                <div class="mr-2">
                    La plaza seleccionada del abonado está de color:
                </div>
                <div
                    :style="{
                        backgroundColor: '#fdf749',
                        width: '20px',
                        height: '20px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        display: 'inline-block'
                    }"
                    title="#fdf749"
                ></div>
            </div>
            <div class="text-center">
                <div v-if="tipo_svg == 1">
                    <SvgPanZoom 
                        class="svgpanzoom-container"
                        :zoomEnabled="true"
                        :controlIconsEnabled="false"
                        :fit="true"
                        :center="true"
                        :mouseWheelZoomEnabled="false"
                        :zoomScaleSensitivity="2"
                        :dblClickZoomEnabled="false"
                        :preventMouseEventsDefault="false"
                        @svgpanzoom="registerSvgPanZoom"
                    >
                        <svg v-html="svg_loaded"/>
                    </SvgPanZoom>
                    <b-popover
                        v-for="plaza in plazas"
                        :key="plaza.id"
                        :target="'popover-' + plaza.id" 
                        triggers="hover"
                    >
                        <div v-if="plaza.concepto"><strong>Concepto: </strong>{{ plaza.concepto }}</div>
                    </b-popover>
                </div>
                <LeafletComponent
                    v-else
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import SvgPanZoom from 'vue-svg-pan-zoom';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';

    export default {
        props: {
            tipo_svg: {
                type: Number
            },
            zona: {
                required: false
            },
            plaza_abonado: {
                type: Object
            }
        },
        data() {
            return {
                svg_loaded : '',
                loading: true,
                svgpanzoom: null,
                svg: null,
                originalColor: '#0CBA31',
                seleccionadaColor: '#8CA9D9',
                bloqueadaColor: '#BF95C4', 
                enSesionColor: 'yellow', 
                vendidaAbonosColor: 'red',
                vendidaEventosColor: 'black',
                bloqueadaEventosColor: 'purple', 
                enSesionEventosColor: 'orange', 
                abonadoNoRenovadoColor: '#B05D04',
                svgRendered: null,
                isPanning: false,
                plazas: null
            }            
        },
        methods: {
            getButacas() {
                this.loading = true;
                let peticion = 'back.lista.settings.recinto.butacas';

                let params = {
                    filters: {},
                    lista_id: this.lista_id,
                    recinto_id: this.recinto_id
                }

                if (this.zona) {
                    params.region_id = this.zona.id
                    peticion = 'back.abonos.listado-butacas-region';
                }

                this.$store.dispatch(this.config.getVuexAlias(peticion), params).then( res => {
                    this.plazas = res.data.data;
                    this.getSvg();
                }).finally(() => this.loading = false);
            },
            getSvg() {
                this.loading = true;
                let peticion = 'front.recinto.svg';

                const params = {
                    recinto_id: this.recinto_id
                };

                if (this.zona) {
                    params.region_id = this.zona.id
                    peticion = 'recinto.zona-svg';
                }

                this.$store.dispatch(this.config.getVuexAlias(peticion), params).then(({ data: { svg } }) => {
                    if (this.tipo_svg == 1) {
                        this.loadSVG(svg);
                    } else {
                        this.renderLeafletSvg(svg);
                    }
                }).finally(() => this.loading = false);
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                setTimeout(() => {
                    let plazas = document.getElementsByClassName("recinto-zona");
                    for(let i in plazas) {
                        if(plazas[i].dataset !== undefined) {
                            let plaza_id = plazas[i].dataset.region;
                            for(let j in this.plazas) {
                                if (this.plazas[j].id == plaza_id) {
                                    if (!this.plazas[j].esta_disponible) {
                                        plazas[i].classList.add("plaza_ocupada");
                                    }
                                    if (this.plazas[j].esta_bloqueada) {
                                        plazas[i].classList.remove("plaza_ocupada");
                                        plazas[i].classList.add("plaza_bloqueada");
                                    }
                                }
                            }
                        }                                                                                            
                    }
                }, 1000);                
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                    if (plaza) {
                        const title = this.getButacaName(plaza);

                        if (plaza.libre && !plaza.ocupada.bloqueada) {     
                            this.drawPopover(circle, plaza, title);      
                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.originalColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickZona(plaza);
                                    }
                                }, 150);
                            });                    
                        } else if (plaza.ocupada && plaza.ocupada.bloqueada) {
                            if (plaza.info_ocupada && plaza.info_ocupada.concepto) {
                                let content = `<div><strong>Concepto: </strong>${plaza.info_ocupada.concepto}</div>`
                                this.drawPopover(circle, plaza, title, content);      
                            }
                            this.drawPopover(circle, plaza, title);    
                            circle.setAttribute('fill', this.bloqueadaColor);
                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning) {
                                        if (!isSeleccionado) {
                                            circle.setAttribute('fill', this.seleccionadaColor);
                                            circle.setAttribute('seleccionado', 'true');
                                        } else {
                                            circle.setAttribute('fill', this.bloqueadaColor);
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickZona(plaza);
                                    }
                                }, 150);
                            }); 
                        } else if (plaza.ocupada && plaza.ocupada.sesion) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.enSesionColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.venta) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaAbonosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.evento_bloqueo) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.bloqueadaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.evento_venta) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.info_ocupada.numero_abonado && plaza.ocupada.renovado) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.info_ocupada.numero_abonado && !plaza.ocupada.renovado) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.abonadoNoRenovadoColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.evento_sesion) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.enSesionEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        }

                        if (plaza.id === this.plaza_abonado?.id){
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', '#fdf749');
                            circle.style.cursor = 'not-allowed';
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },
            drawPopover(circle, plaza, title = null, content = '') {
                if (plaza.ocupada) {
                    if (plaza.ocupada.bloqueada) {
                        content += `<div><strong>Plaza bloqueada</strong></div>`;
                    }
                    if (plaza.ocupada.venta) {
                        content += `<div><strong>Vendida</strong></div>`;
                    }
                    if (plaza.ocupada.sesion) {
                        content += `<div><strong>En sesión</strong></div>`;
                    }
                    if (plaza.ocupada.evento_venta) {
                        content += `<div><strong>Vendida en evento</strong></div>`;
                    }
                    if (plaza.ocupada.evento_bloqueo) {
                        content += `<div><strong>Bloqueada en evento</strong></div>`;
                    }
                    if (plaza.ocupada.evento_sesion) {
                        content += `<div><strong>En sesión en evento</strong></div>`;
                    }
                    if (plaza.info_ocupada.numero_abonado && !plaza.ocupada.renovado) {
                        content += `<div><strong>Abonado no renovado</strong></div>`;
                    }
                    if (plaza.info_ocupada.qr_abonado) {
                        content += `<div><strong>Código QR: ${plaza.info_ocupada.qr_abonado}</strong></div>`
                    }
                    if (plaza.info_ocupada.id_abonado) {
                        circle.style.cursor = 'pointer';
                        circle.addEventListener('click', () => {
                            let url = `/admin/abonados/${this.lista_id}/${plaza.info_ocupada.id_abonado}`;
                            window.open(url, '_blank');
                        });
                    }
                }

                if (plaza.libre) {
                    content = `<div><strong>Plaza libre</strong></div>`;
                }

                const popoverOptions = {
                    title: title,
                    content: content,
                    trigger: 'hover',
                    html: true
                };

                new Popover(circle, popoverOptions);
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            clickZona(plazaSeleccionada) {
                const plazaEncontrada = this.plazas.find(plaza => plaza.id === plazaSeleccionada.id);

                if (plazaEncontrada) {
                    plazaEncontrada.seleccionada = !plazaEncontrada.seleccionada; 

                    this.$emit('cambiarPlaza', null, null, 0, plazaEncontrada.id);
                }
            },
            registerSvgPanZoom(svgpanzoom) {
                this.svgpanzoom = svgpanzoom;
            },
            zoomIn() {
                this.svgpanzoom.zoomIn();
            },
            zoomOut() {
                this.svgpanzoom.zoomOut();
            }
        },
        computed: {
            lista_id() {
                return this.$store.getters.getListaId;
            },
            recinto_id() {
                return this.$store.getters.getRecinto.id;
            }
        },
        created() {
            this.getButacas();
        },
        components: { SvgPanZoom, LeafletComponent }
    }
</script>